"use client";
import * as React from "react";
const SvgVisibilityOffFilled = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 16 14", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M8 3a3.64 3.64 0 0 1 3.64 3.64q-.01.71-.26 1.33l2.12 2.13A8.6 8.6 0 0 0 16 6.63a8.6 8.6 0 0 0-8-5.46 9 9 0 0 0-2.9.51l1.57 1.57A4 4 0 0 1 8 3M.73 1.01l1.99 2A8.6 8.6 0 0 0 0 6.64a8.6 8.6 0 0 0 8 5.46 9 9 0 0 0 3.2-.62l.3.31 2.13 2.13.92-.93L1.65.09zm4.02 4.03 1.13 1.13a2 2 0 0 0-.06.47A2.2 2.2 0 0 0 8 8.82q.24 0 .48-.06L9.6 9.9a4 4 0 0 1-1.6.39 3.64 3.64 0 0 1-3.63-3.64q.01-.87.38-1.6Zm3.14-.57 2.29 2.3.01-.12a2.2 2.2 0 0 0-2.18-2.19z" }));
export {
  SvgVisibilityOffFilled as default
};
